import React from 'react';
import { useMediaQuery } from '@react-hook/media-query';
import { FormattedMessage } from 'react-intl';

import { assetsBaseUrl } from "../services/calculationsApi";
import {addOfficeIdParamToLink, mainMediaMobile} from "../services/helpers";

function Header() {
  const mediaMatches = useMediaQuery(mainMediaMobile);

  return (
  <header className="ct-header">
    <div className="ct-header__content">
      <div>
        <a href="https://www.hypotheker.nl/">
          <img style={ (!mediaMatches) ? { marginTop: 25 } : {} } height={ (mediaMatches) ? 48 : 90} src={`${assetsBaseUrl}/assets/${mediaMatches ? 'logo-no-text-40-year.svg' : 'logo-no-text-40-year.svg'}`} alt="Jazeker. De Hypotheker"/>
        </a>
      </div>

      <div className="ct-header__buttons">
        <a href="https://www.hypotheker.nl/vestigingen/" className="ct__button ct-header__vestigingen">
          <FormattedMessage id="header.branches" defaultMessage="Vestigingen" />
        </a>

        <a href={addOfficeIdParamToLink(`https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur/`)} className="ct__button ct-header__afspraak">
          <FormattedMessage id="header.appointment" defaultMessage="Afspraak maken" />
        </a>
      </div>
    </div>
  </header>
  );
}

export default Header;
